/* 🤖 this file was generated by svg-to-ts */
export const myIconTick: {
  name: 'tick';
  data: string;
} = {
  name: 'tick',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path fill="currentColor" d="M378-241q-9 0-17.5-3.5T345-255L164-436q-14-14-14-34t14-34q14-14 33.5-14t34.5 14l146 146 350-349q14-14 33.5-14.5T795-707q14 14 14 34t-14 34L411-255q-7 7-15.5 10.5T378-241Z"/></svg>`,
};
